import { Column, Entity, JoinColumn, ManyToOne, OneToMany } from 'typeorm';
import { BaseEntity } from './base.entity';
import { ObjectEntity } from './object.entity';
import { OutreachAudienceContactEntity } from './outreach-audience-contact.entity';
import { OutreachCampaignAudienceEntity } from './outreach-campaign-audience.entity';

@Entity('_outreach_audience')
export class OutreachAudienceEntity extends BaseEntity {
	@Column('varchar', { name: '_name', length: 255 })
	public name!: string;

	@Column('enum', { name: '_campaign_type', enum: ['email', 'phone'] })
	public campaignType!: 'email' | 'phone';

	@Column('enum', { name: '_type', enum: ['dynamic', 'static'] })
	public type!: 'dynamic' | 'static';

	@Column('text', { name: '_query', nullable: true })
	public query!: string | null;

	@Column('text', { name: '_query_fields_map', nullable: true })
	public queryFieldsMap!: string | null;

	@Column('text', { name: '_description', nullable: true })
	public description!: string | null;

	@ManyToOne(() => ObjectEntity, (object) => object.outreachAudiences, {
		onDelete: 'NO ACTION',
		onUpdate: 'NO ACTION',
	})
	@JoinColumn([{ name: '_fk__object__id', referencedColumnName: 'id' }])
	public fkObject!: ObjectEntity;

	@OneToMany(
		() => OutreachAudienceContactEntity,
		(outreachAudienceContact) => outreachAudienceContact.fkOutreachAudience,
		{},
	)
	public outreachAudienceContacts!: Array<OutreachAudienceContactEntity>;

	@OneToMany(
		() => OutreachCampaignAudienceEntity,
		(outreachCampaignAudience) => outreachCampaignAudience.fkOutreachAudience,
		{},
	)
	public outreachCampaignAudiences!: Array<OutreachCampaignAudienceEntity>;
}
